export const getColorArray = (num) => {
    const result = []
    for (let i = 0; i < num; i += 1) {
        const letters = '0123456789ABCDEF'.split('')
        let color = '#'
        for (let j = 0; j < 6; j += 1) {
            color += letters[Math.floor(Math.random() * 16)]
        }
        result.push(color)
    }
    return result
}

